module.exports = __webpack_public_path__ + "resources/img/img_t3q_search_jp.9850661d09b46d7919c4b00bd0c8319a.png";